import { LeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FlexContainer } from '../../styles/Global';

interface Prop {
  title?: string;
  showBackButton?: boolean;
  addButton?: React.ReactNode;
  addButtonText?: string;
  customBlock?: React.ReactNode;
  onBack?: () => void;
}

const PageHeader = ({
  title,
  showBackButton = false,
  addButton = false,
  addButtonText = '',
  customBlock,
  onBack,
}: Prop) => {
  const navigate = useNavigate();

  return (
    <PageHeaderContainer $showAddButton={!!addButton || !!customBlock}>
      <FlexContainer>
        {showBackButton && (
          <LeftOutlined size={20} onClick={() => navigate(-1)} />
        )}
        {title && <PageTitle>{title}</PageTitle>}
      </FlexContainer>
      {!!addButton && addButton}
      {!!customBlock && customBlock}
    </PageHeaderContainer>
  );
};

export default PageHeader;

const PageHeaderContainer = styled.div<{ $showAddButton: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
  padding: 12px 20px;
  margin: 0 -20px 20px -20px;

  span.anticon.anticon-left {
    color: #000000;
    margin-right: 8px;
  }

  ${({ $showAddButton }) => $showAddButton && `justify-content: space-between;`}
`;

const PageTitle = styled.h2`
  font-size: 20px;
  letter-spacing: 0.06rem;
  line-height: 30px;
  color: var(--color-primary-black);
`;
